import http from "../api/axios-auth-php";

class RecognitionSettingsService {
    // Get recognition settings for a specific client
    getSettings(clientId) {
        return http.get(`client-recognition-settings/${clientId}`);
    }

    // Create or update recognition settings
    saveSettings(data) {
        return http.post("client-recognition-settings", data);
    }

    // Toggle recognition module on/off for a client
    toggleModule(clientId, data) {
        return http.put(`client-recognition-settings/${clientId}/toggle`, data);
    }

    // Delete recognition settings for a client
    deleteSettings(clientId) {
        return http.delete(`client-recognition-settings/${clientId}`);
    }
}

export default new RecognitionSettingsService();